<template>
  <div class="manage_user" v-if="clazz">
    <clazz-show-header :clazz="clazz" />

    <van-list
      v-model="loading"
      class="bgwhite"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <user-cell
        class="bgwhite"
        v-for="(item, index) in list"
        :key="index"
        :clazz-user="item"
        :is-manager="clazz.is_manager"
      />
    </van-list>
  </div>
</template>

<script>
import { List } from 'vant'
import UserCell from './components/UserCell'
import ClazzShowHeader from '@/views/clazz/components/ClazzShowHeader'
import { clazzSimpleInfo } from '@/api/clazz'
import { manageClazzUserList } from '@/api/clazz_manage'

export default {
  name: 'ManageUser',
  components: {
    [List.name]: List,
    ClazzShowHeader,
    UserCell
  },
  data () {
    return {
      clazz: null,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        page: 0,
        size: 8
      }
    }
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(this.clazzId)
    this.getList(this.clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      this.clazz = response.data
    },
    async getList (clazzId) {
      this.loading = true
      let response = await manageClazzUserList(clazzId, this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList(this.clazzId)
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
.manage_user {
  background-color: #f8f8f8;
}
</style>
